module.exports = __webpack_public_path__ + "img/roullet_board.f4c0df56.png";